import React, { useContext } from 'react'
import { DisplayContext } from '../contexts'
import { TypeDisplayContext } from '../contexts'

const useDisplayContext = (): TypeDisplayContext => {
    return useContext(DisplayContext)
}

export default useDisplayContext
